module.exports = __webpack_public_path__ + "img/youzheng.98f02f75.png";